import type { StandardEquipmentCatalogue } from "../../../configurator";
import {
  HYDRATE_CATALOGUE,
  REVERT_CATALOGUE_DRAFT,
  SAVE_CATALOGUE_SUCCESS,
  UPDATE_CATALOGUE_DRAFT,
} from "../types";

export interface CatalogueState {
  active: StandardEquipmentCatalogue;
  saved: StandardEquipmentCatalogue;
}

const initialState: CatalogueState = {
  active: { powerSources: [], coilFrames: [], bottomEnds: [] },
  saved: { powerSources: [], coilFrames: [], bottomEnds: [] },
};

type CatalogueAction =
  | { type: typeof HYDRATE_CATALOGUE; catalogue: StandardEquipmentCatalogue }
  | { type: typeof UPDATE_CATALOGUE_DRAFT; catalogue: StandardEquipmentCatalogue }
  | { type: typeof REVERT_CATALOGUE_DRAFT }
  | { type: typeof SAVE_CATALOGUE_SUCCESS; catalogue: StandardEquipmentCatalogue };

const catalogueReducer = (state = initialState, action: CatalogueAction): CatalogueState => {
  switch (action.type) {
    case HYDRATE_CATALOGUE:
      return { active: action.catalogue, saved: action.catalogue };
    case UPDATE_CATALOGUE_DRAFT:
      return { ...state, active: action.catalogue };
    case REVERT_CATALOGUE_DRAFT:
      return { ...state, active: state.saved };
    case SAVE_CATALOGUE_SUCCESS:
      return { active: action.catalogue, saved: action.catalogue };
    default:
      return state;
  }
};

export default catalogueReducer;
